<script setup lang="ts">
// Navigation for default theme (depth 1 is 2 level navi, depth 2 is 3 level navi, and so on)
const { loadNavigationElements } = useNavigation();
const { data } = useAsyncData("mainNavigation", () => {
  return loadNavigationElements({ depth: 1 });
});
provide("swNavigation-main-navigation", data);

const { loadNavigationElements: loadFooterNavigationElements } = useNavigation({
  type: "footer-navigation",
});
const { data: footerData } = useAsyncData("mainFooterNavigation", () => {
  return loadFooterNavigationElements({ depth: 1 });
});
provide("swNavigation-footer-navigation", footerData);

const { loadNavigationElements: loadTopNavigationElements } = useNavigation({
  type: "service-navigation",
});
const { data: topNavigationData } = useAsyncData("mainServiceNavigation", () => {
  return loadTopNavigationElements({ depth: 1 });
});
provide("swNavigation-service-navigation", topNavigationData);

const miniCartModal = useMiniCartModal();

const route = useRoute();
const activeTab = ref(route.path === "/login" ? "login" : "register");

// Add this watch to update activeTab when route changes
watch(
  () => route.path,
  (newPath) => {
    activeTab.value = newPath === "/login" ? "login" : "register";
  }
);
</script>

<template>
  <LayoutHeader />
  <CheckoutSideCart :controller="miniCartModal" />
  <LayoutNotifications />
  
  <!-- Mobile Tabs -->
  <div class="md:hidden px-4 md:pt-6 mt-8 md:mt-0">
    <div class="flex">
      <NuxtLink
        to="/login"
        class="py-1 px-0 text-center transition-colors duration-200 font-bold"
        :class="{
          'text-dark border-b-3 border-dark': activeTab === 'login',
          'text-gray-500 hover:text-gray-700': activeTab !== 'login',
        }"
      >
        {{ $t("account.signInLabel") }}
      </NuxtLink>
      <NuxtLink
        to="/register"
        class="py-1 px-0 text-center transition-colors duration-200 ml-6 font-bold"
        :class="{
          'text-primary border-b-3 border-dark': activeTab === 'register',
          'text-gray-500 hover:text-gray-700': activeTab !== 'register',
        }"
      >
        {{ $t("account.signUpHeader") }}
      </NuxtLink>
    </div>
  </div>

  <div class="min-h-screen flex flex-col">
    <div class="flex-1 flex flex-col md:flex-row relative">
      <!-- Container wrapper for both sections -->
      <div class="container mx-auto">
        <!-- Content -->
        <slot />

        <!-- Background colors (absolute positioned) -->
        <div class="absolute inset-0 z-[-1]">
          <div class="h-full flex flex-col md:flex-row">
            <div class="flex-1 bg-white"></div>
            <div class="flex-1 bg-gray-50"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LayoutFooter />
</template>
